"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var distill;
(function (distill) {
    var dashboards;
    (function (dashboards) {
        class DashboardDesigner extends appn.designerv2.DesignerBase {
            constructor(datasets, restrictedDatasets, aiQueryUrl, itemList, editUserUrl) {
                super();
                this.maxGlobalFilters = 5;
                appn.designerv2.canvas = new dashboards.GridStackCanvas({
                    float: true,
                    itemClass: 'component',
                    acceptWidgets: true,
                    cellHeight: 'initial',
                    resizable: {
                        handles: 'e, se, s, sw, w, nw, n, ne'
                    }
                });
                appn.designerv2.toolPane = new appn.designerv2.ToolPaneBase();
                this._datasets = datasets || [];
                this._restrictedDatasets = restrictedDatasets || [];
                this._aiQueryUrl = aiQueryUrl || appn.emptyString;
                this._itemList = itemList || [];
                this._editUserUrl = editUserUrl || appn.emptyString;
            }
            getItemList() {
                return this._itemList;
            }
            init(args) {
                super.init(args);
                dashboards.designer = this;
                this.maxGlobalFilters = args.maxGlobalFilters || this.maxGlobalFilters;
                distill.dataCache.init(1000 * 60 * 60 * 24 * 365);
                dashboards.dataManager.init(args.dataFetchUrl);
            }
            captureComponentSnapshots(component) {
                const definition = distill.componentManager.getDefinition(component.type);
                if (!definition)
                    return;
                distill.componentManager.getDataQueryPropertyNames(definition).forEach(dataQueryPropName => {
                    const dataQuery = component[dataQueryPropName];
                    if (dataQuery && dashboards.getDatasetRefsInDataQuery(dataQuery).some(ref => this.isRestricted(ref.id)))
                        this.snapshotRoot(component.id, dataQueryPropName);
                });
            }
            bindEvents() {
                super.bindEvents();
                dashboards.dataManager.bindEvents();
                this.bindRenderEvents();
                let lastWindowWidth = window.innerWidth;
                window.addEventListener('resize', () => {
                    if (window.innerWidth === lastWindowWidth)
                        return;
                    lastWindowWidth = window.innerWidth;
                    const canvas = appn.designerv2.canvas;
                    if (canvas && canvas._grid && canvas._grid.el) {
                        const gridWidth = canvas._grid.el.clientWidth;
                        const newCellHeight = Math.floor(gridWidth / 12);
                        if (newCellHeight > 0) {
                            canvas._grid.cellHeight(newCellHeight);
                        }
                    }
                });
                setTimeout(() => {
                    window.dispatchEvent(new Event('resize'));
                }, 150);
            }
            updateGlobalFilters(filters) {
                if (!this._design)
                    return;
                const design = this._design;
                const oldValue = design.globalFilters;
                design.globalFilters = appn.utils.deepClone(filters);
                distill.eventBus.publish(distill.EVENTS.STATE_CHANGED, { design: this._design });
                const titleBar = design.components.find(component => component.type === dashboards.ComponentType.titleBar);
                if (titleBar)
                    distill.eventBus.propertyUpdated(titleBar.id, 'globalFilters', design.globalFilters, oldValue);
            }
            createDefaultDesign(name) {
                const pieChart = distill.componentManager.createComponent(dashboards.ComponentType.pieChart);
                const defaultChildren = [];
                if (pieChart) {
                    pieChart.gridPosition = { x: 2, y: 1, w: 4, h: 3 };
                    defaultChildren.push(pieChart);
                }
                return {
                    title: name,
                    metadata: [{ activeLanguages: ['eng'] }],
                    globalFilters: [],
                    components: [
                        { id: appn.utils.newGuid(true), type: dashboards.ComponentType.titleBar, title: { eng: name } },
                        { id: appn.utils.newGuid(true), type: dashboards.ComponentType.group, children: defaultChildren }
                    ]
                };
            }
            onUpdateComponentProperty(component, propName, oldValue) {
                return true;
            }
            getDatasets() {
                return this._datasets;
            }
            getDesignDatasetIds() {
                const design = this.getDesignForSave();
                if (!design)
                    return [];
                const datasetIds = new Set();
                const collect = (components) => {
                    components.forEach(component => {
                        dashboards.getDatasetRefsInComponent(component).forEach(datasetRef => {
                            if (datasetRef.id)
                                datasetIds.add(datasetRef.id);
                        });
                        if (component.children)
                            collect(component.children);
                    });
                };
                collect(design.components);
                return Array.from(datasetIds);
            }
            getRestrictedDatasets() {
                return this._restrictedDatasets;
            }
            isRestricted(datasetId) {
                return !!datasetId && this._restrictedDatasets.some(t => t.id === datasetId);
            }
            bindRenderEvents() {
                distill.eventBus.subscribe(distill.EVENTS.DATA_FETCH_SUCCESS, (result) => {
                    const refreshedComponentIds = new Set();
                    result.Views.forEach(datasetResult => {
                        const cacheKey = appn.utils.normalizeIdentifier(datasetResult.Name);
                        const componentId = cacheKey.split('.')[0];
                        if (componentId) {
                            if (datasetResult.Error) {
                                const cachedResult = distill.dataCache.get(cacheKey);
                                if (cachedResult && cachedResult.ObjectResult && cachedResult.ObjectResult.length > 0) {
                                    datasetResult.ObjectResult = cachedResult.ObjectResult;
                                    datasetResult.Headers = cachedResult.Headers;
                                }
                            }
                            if (appn.utils.hasValue(datasetResult.Error))
                                console.error(`Could not fetch data for ${cacheKey}`, datasetResult.Error);
                            refreshedComponentIds.add(componentId);
                            distill.dataCache.set(cacheKey, datasetResult);
                        }
                    });
                    if (!result || !result.Views)
                        return;
                    refreshedComponentIds.forEach(id => {
                        const component = dashboards.designer.getComponent(id);
                        if (!component)
                            return;
                        const definition = distill.componentManager.getDefinition(component.type);
                        if (!definition || !definition.render)
                            return;
                        const element = $(`#${id}`);
                        if (!element.length)
                            return;
                        definition.render(element, component);
                    });
                });
                distill.eventBus.subscribeToPropertyUpdates(payload => {
                    const component = dashboards.designer.getComponent(payload.componentId);
                    if (!component)
                        return;
                    const definition = distill.componentManager.getDefinition(component.type);
                    if (!definition || !definition.render)
                        return;
                    const dataQueryPropNames = distill.componentManager.getDataQueryPropertyNames(definition);
                    if (dataQueryPropNames.includes(payload.propName))
                        return;
                    const element = $(`#${component.id}`);
                    if (!element.length)
                        return;
                    definition.render(element, component);
                });
                distill.eventBus.subscribe(dashboards.DASH_EVENTS.AI_QUERY_SEND, (payload) => __awaiter(this, void 0, void 0, function* () {
                    try {
                        const response = yield fetch(this._aiQueryUrl, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify(Object.assign(Object.assign({}, payload), { datasetIds: this.getDesignDatasetIds() }))
                        });
                        if (!response.ok)
                            throw new Error(`HTTP error! status: ${response.status}`);
                        const json = yield response.json();
                        distill.eventBus.publish(dashboards.DASH_EVENTS.AI_QUERY_RESULT, {
                            componentId: payload.component.id,
                            response: json,
                            success: true,
                            upgradeUrl: this._editUserUrl,
                        });
                    }
                    catch (error) {
                        distill.eventBus.publish(dashboards.DASH_EVENTS.AI_QUERY_RESULT, {
                            componentId: payload.component.id,
                            response: null,
                            success: false,
                            upgradeUrl: this._editUserUrl,
                        });
                    }
                }));
            }
        }
        dashboards.DashboardDesigner = DashboardDesigner;
    })(dashboards = distill.dashboards || (distill.dashboards = {}));
})(distill || (distill = {}));
